import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { Component, OnInit } from '@angular/core';
import { PageHeaderComponent } from '../../header/page-header/page-header.component';
import { PageNoHeaderComponent } from '../../header/page-no-header/page-no-header.component';
import { ThumbnailControl } from '../../modals/thumbnails/thumbnail/thumbnail.control';

@NgModule({
  imports: [CommonModule,
            IonicModule,
            FormsModule,
            RouterModule],
  declarations: [ PageHeaderComponent, PageNoHeaderComponent,ThumbnailControl],
  exports:      [ PageHeaderComponent, PageNoHeaderComponent,ThumbnailControl]
})
export class SharedheaderModule { }
